module.exports = __webpack_public_path__ + "static/img/ls4.a49b009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls4.png
// module id = CS6y
// module chunks = 12